import React, { useState } from "react"
import {Button, Nav, Tab, Tabs, TabSuffix} from "@visa/nova-react";
import {VisaChevronDownTiny, VisaChevronUpTiny} from "@visa/nova-icons-react";

export default function VDSUINavigation({items,handleNavClick,urlIdArray}) {
    const [selectedId, setSelectedId] = useState(null);
    const [activeMenuOpen, setActiveMenuOpen] = useState([]);
    const [navMenuItemClicked, setNavMenuItemClicked] = useState(false);
    return(
        <Nav aria-label="Vertical nav with links" orientation="vertical" role="navigation">
        <Tabs className="v-gap-8" orientation="vertical" role="tablist">
            {
                items.map((item, key) =>
                    <MenuItem key={key} item={item}
                              handleNavClick={handleNavClick}
                              selectedId={selectedId} setSelectedId={setSelectedId}
                              activeMenuOpen={activeMenuOpen} setActiveMenuOpen={setActiveMenuOpen}
                              navMenuItemClicked={navMenuItemClicked} setNavMenuItemClicked={setNavMenuItemClicked}
                              expand={hasMatchingChild(item, urlIdArray)}
                              urlIdArray={urlIdArray}

                />)
            }
        </Tabs>
        </Nav>
    );
}

const MenuItem = ({ item, handleNavClick, selectedId, setSelectedId, activeMenuOpen, setActiveMenuOpen, navMenuItemClicked, setNavMenuItemClicked, expand, urlIdArray }) => {
    const hasChildrenItems = hasChildren(item);
    const Component = hasChildrenItems ? MultiLevel : SingleLevel;
    const hideMainProduct = !hasChildrenItems && item.id.endsWith("_mainProduct");
    if(hasChildrenItems && activeMenuOpen && activeMenuOpen.length === 2 && activeMenuOpen[0].endsWith("_mainProduct") && item.id === activeMenuOpen[1] && !(urlIdArray[2] === selectedId)) {
        setSelectedId(item.items[0].id)
    }
    return <Component item={item} component="ul" handleNavClick={handleNavClick}
                      selectedId={selectedId} setSelectedId={setSelectedId} hideItem={hideMainProduct}
                      activeMenuOpen={activeMenuOpen} setActiveMenuOpen={setActiveMenuOpen}
                      navMenuItemClicked={navMenuItemClicked} setNavMenuItemClicked={setNavMenuItemClicked}
                      expand={expand} urlIdArray={urlIdArray}
    />;
};

const SingleLevel = ({ item, handleNavClick, selectedId, setSelectedId, hideItem, activeMenuOpen, setActiveMenuOpen, expand, urlIdArray  }) => {
    const id = item.id;
    const handleClick = (e, idVal) => {
        e.preventDefault();
        setSelectedId(idVal.id);
        if(id === 'static-api-endpoints-section' || id === 'static-home-section'){
            setActiveMenuOpen([id])
        }
        handleNavClick(idVal);
    }

    if(urlIdArray && urlIdArray[2]) {
        setSelectedId(urlIdArray[2]);
    }

    return (
        <React.Fragment>
        { !hideItem &&
            <Tab role="none">
                <Button colorScheme="tertiary" element={<a href={item.id}>{item.title}</a>} role="tab"
                        onClick={(e) => handleClick(e, { id })}
                        aria-selected={(selectedId === id) || (urlIdArray && urlIdArray[0] === id)} tabIndex={0}/>
            </Tab>
        }
        </React.Fragment>
    );
};

const MultiLevel = ({ item, handleNavClick, selectedId, setSelectedId, activeMenuOpen, setActiveMenuOpen, navMenuItemClicked, setNavMenuItemClicked, expand, urlIdArray  }) => {
    const { items: children } = item;
    const groupedItems = groupByHeader(children);
    const groupedItemsSize = Object.keys(groupedItems).length;
    const isOpen = activeMenuOpen.includes(item.id);
    if(expand && !navMenuItemClicked && !activeMenuOpen.includes(urlIdArray[0])){
            if(item.id.endsWith("_mainProduct")){
                setActiveMenuOpen([item.id, ...urlIdArray.slice(0,2)]);
            } else {
                setActiveMenuOpen(prevArray => [...new Set([...prevArray, ...urlIdArray.slice(0,2)])]);
            }
    }
    const handleClick = (item) => {
        const id = item.id;
        const isMainProduct = id.endsWith("_mainProduct");
        setNavMenuItemClicked(true);
        if(activeMenuOpen.includes(id)){
            setActiveMenuOpen(activeMenuOpen.filter(arr => !arr.includes(id)));
        } else {
            if (activeMenuOpen.length === 0 && isMainProduct) {
                setActiveMenuOpen([id]);
            } else if (activeMenuOpen.length === 1) {
                if (activeMenuOpen[0] === id && activeMenuOpen[0].endsWith("_mainProduct")) {
                    setActiveMenuOpen([]);
                } else if (activeMenuOpen[0] !== id && isMainProduct) {
                    setActiveMenuOpen([id]);
                } else if (!isMainProduct) {
                    setActiveMenuOpen([...activeMenuOpen, id]);
                }
            } else if (activeMenuOpen.length > 1) {
                if (!isMainProduct && activeMenuOpen.includes(id)) {
                    setActiveMenuOpen(prevArray => [...prevArray.slice(0, -1)]);
                } else if (!isMainProduct) {
                    setActiveMenuOpen(prevArray => [...prevArray.slice(0, -1), id]);
                } else {
                    setActiveMenuOpen([id]);
                }
            }
        }
        handleNavClick({id});
    };
    return (
        <React.Fragment>
            <Tab role="none">
                <Button
                    colorScheme="tertiary"
                    role="tab"
                    onClick={() => handleClick(item)}
                    aria-expanded={isOpen || (!navMenuItemClicked && expand)}
                >
                  	<span style={{ fontWeight: (isOpen || (!navMenuItemClicked && expand)) ? 'bold' : 'normal' }}>
                   		{item.title}
					</span>
                    <TabSuffix element={(isOpen || (!navMenuItemClicked && expand)) ? <VisaChevronUpTiny /> : <VisaChevronDownTiny />} />
                </Button>
                {(isOpen || (!navMenuItemClicked && expand)) && <Tabs orientation="vertical" role="none">
                    {
                        groupedItemsSize>0 && Object.entries(groupedItems).map(([header, children], key) => (
                            <React.Fragment key={key}>
                                <Tab role="none" sectionTitle>
                                    <span>{header}</span>
                                </Tab>
                                {children.map((child, key) =>
                                    <MenuItem key={key} item={child}
                                              handleNavClick={handleNavClick}
                                              selectedId={selectedId} setSelectedId={setSelectedId}
                                              activeMenuOpen={activeMenuOpen} setActiveMenuOpen={setActiveMenuOpen}
                                              expand={urlIdArray && urlIdArray[0] && child.id === urlIdArray[0]}
                                              navMenuItemClicked={navMenuItemClicked} setNavMenuItemClicked={setNavMenuItemClicked}
                                    />)}
                            </React.Fragment>
                        ))
                    }
                    { groupedItemsSize===0 && children.map((child, key) => (
                        <MenuItem key={key} item={child} handleNavClick={handleNavClick}
                                  selectedId={selectedId} setSelectedId={setSelectedId}
                                  activeMenuOpen={activeMenuOpen} setActiveMenuOpen={setActiveMenuOpen}
                                  navMenuItemClicked={navMenuItemClicked} setNavMenuItemClicked={setNavMenuItemClicked}
                                  expand={urlIdArray && urlIdArray[0] && child.id === urlIdArray[0]} urlIdArray={urlIdArray} />
                    ))}
                </Tabs>}
            </Tab>
        </React.Fragment>
    );
};

const hasMatchingChild = (item, urlIdArray) => {
    if(item.items && item.items.length > 0 && urlIdArray && urlIdArray[0]) {
        const hasMatchingChildVal = item.items.some(child => child.id === urlIdArray[0]);
        return hasMatchingChildVal;
    }
    return false;
}

const  hasChildren = (item) => {
    const { items: children } = item;
    if (children === undefined) {
        return false;
    }

    if (children.constructor !== Array) {
        return false;
    }

    if (children.length === 0) {
        return false;
    }

    return true;
}

const groupByHeader = (items) => {
    return items.reduce((groupedItems, item) => {
        if(item.header) {
            (groupedItems[item.header] = groupedItems[item.header] || []).push(item);
        }
        return groupedItems;
    }, {});
};
